import { Component, input, output } from '@angular/core';
import { LucideAngularModule, Settings } from 'lucide-angular';
import { SurveyListOption } from '@hyper-inferno/survey-elements-core';

@Component({
  selector: 'lib-dynamic-list-preview',
  standalone: true,
  imports: [LucideAngularModule],
  templateUrl: './dynamic-list-preview.html',
  styleUrl: './dynamic-list-preview.css',
})
export class DynamicListPreview {
  displayNames = input<SurveyListOption[]>([]);

  extraButton = input<string | undefined>();

  editListEvent = output<void>();

  configurationSettingEvent = output<string>();

  readonly SettingsIcon = Settings;

  editList() {
    this.editListEvent.emit();
  }

  handleConfigurationSetting(itemId: string) {
    this.configurationSettingEvent.emit(itemId);
  }
}
